




































import Vue, { PropType } from 'vue'

export type DataType = {
  roomName: string,
}

export default Vue.extend({
  name: 'CardRoomName',

  props: {
    errorMessage: String,
  },

  data(): DataType {
    return {
      roomName: '',
    }
  },

  methods: {
    searchRoom(): void {
      this.$emit('searchRoom', this.roomName)
    },

    cancel(): void {
      this.$emit('cancel')
    },
  },
})
